import RegistrationForm from "@/components/RegistrationForm";
import { Building2 } from "lucide-react";

export default function PublicRegistration() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-slate-900 text-slate-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-blue-800 flex items-center justify-center">
            <Building2 className="h-5 w-5" />
          </div>
          <div>
            <p className="font-heading font-bold text-base leading-tight">Haryana Safai Mahakumbh</p>
            <p className="text-[11px] text-slate-400 uppercase tracking-wider">
              Citizen Event Registration
            </p>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-8 space-y-6">
        <div className="text-center">
          <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
            Citizen Registration
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Fill in your details to register. You'll receive a unique Registration ID.
          </p>
        </div>
        <RegistrationForm />
        <p className="text-center text-xs text-slate-400 pb-4">
          Government of Haryana · Urban Local Bodies Department
        </p>
      </main>
    </div>
  );
}
